module.exports = __webpack_public_path__ + "img/MapDetailsBG.1df8b393.webp";